type NullableEmail = string | null | undefined;

export function normalizeEmail(value: string): string;
export function normalizeEmail(value: string | null): string | null;
export function normalizeEmail(value: string | undefined): string | undefined;
export function normalizeEmail(value: null): null;
export function normalizeEmail(value: undefined): undefined;
export function normalizeEmail(value: NullableEmail): NullableEmail;
export function normalizeEmail(value: NullableEmail): NullableEmail {
  if (value == null) return value;
  return value.trim().toLowerCase();
}

export function normalizeEmailFields<T extends Record<string, unknown>, K extends keyof T>(
  values: T,
  keys: readonly K[]
): T {
  return keys.reduce<T>(
    (nextValues, key) => {
      if (!(key in nextValues)) {
        return nextValues;
      }
      const value = nextValues[key];
      if (typeof value === 'string' || value == null) {
        return {
          ...nextValues,
          [key]: normalizeEmail(value as NullableEmail)
        };
      }
      return nextValues;
    },
    { ...values }
  );
}
